// IT
export const locale = {
	lang: 'it',
	data: {
		MENU: {
			TEST: 'SCOPRI COME FUNZIONA'
        }
    }
}